import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { signInPage } from './extensions/auth/entraSignIn';
import { scmIntegrationsApi } from './extensions/apis/scmIntegrationsApi';
import { SidebarContent } from './modules/nav/Sidebar';
import { autoLogout } from './extensions/auth/autoLogout';
import { rootRedirect } from './extensions/pages/rootRedirect';
import { adrSearchResultType } from './extensions/search/adrSearchResultType';
import { adrSearchResultListItemIcon } from './extensions/search/adrSearchResultListItemIcon';
import { systemSearchFilter } from './extensions/search/systemSearchFilter';
import { techDocsIndexPageWithKindFilter } from './extensions/techdocs/techDocsIndexPage';
import { createStaticContentPlugin } from './plugins/staticContent/staticContentPlugin';
import { staticExternalPagesPlugin } from './plugins/staticExternalPages/staticExternalPagesPlugin';
import { hostedApplicationsPlugin } from './plugins/hostedApplications/hostedApplicationsPlugin';
import scorecardsPlugin from '@internal/plugin-scorecards';
import techDocsPlugin from '@backstage/plugin-techdocs/alpha';
import { techDocsMermaidAddonModule } from "backstage-plugin-techdocs-addon-mermaid";
import techdocsEditorPlugin from '@estehsaan/backstage-plugin-techdocs-editor/alpha';
import mcpChatPlugin from '@backstage-community/plugin-mcp-chat/alpha';
import { mcpChatFeatureFlagPlugin } from './extensions/mcpChatFeatureFlag';

// App Export
export default createApp({
  features: [
    techDocsPlugin,
    techdocsEditorPlugin,
    techDocsMermaidAddonModule,
    mcpChatPlugin,
    mcpChatFeatureFlagPlugin,
    createStaticContentPlugin(),
    staticExternalPagesPlugin,
    hostedApplicationsPlugin,
    scorecardsPlugin,
    createFrontendModule({
      pluginId: 'app',
      extensions: [
        signInPage,
        autoLogout,
        rootRedirect,
        SidebarContent,
        scmIntegrationsApi,
        systemSearchFilter,
      ],
    }),
    // Registered under the 'techdocs' plugin's own ID so
    // techDocsIndexPageWithKindFilter overrides its page:techdocs extension
    // in place (see the note in that file).
    createFrontendModule({
      pluginId: 'techdocs',
      extensions: [techDocsIndexPageWithKindFilter],
    }),
    // Registered under the 'adr' plugin's own ID (not 'app') so
    // adrSearchResultListItemIcon overrides that plugin's
    // search-result-list-item extension in place. adrSearchResultType is
    // colocated here too since it's also ADR-specific, even though it's a
    // new extension rather than an override.
    createFrontendModule({
      pluginId: 'adr',
      extensions: [adrSearchResultListItemIcon, adrSearchResultType],
    }),
  ],
});